import { bindable } from 'aurelia';
import { formatDate } from '../../services/date-formatter'

export class DestinationGroupDetailsFlightinfo {

    @bindable metaId;
    @bindable packagegroupId;

    RESOURCE_BASE_URL = aurelia_options.resourceBaseUrl;
    aurelia_options = aurelia_options;
    flightinfo = null;
    flightInfoStatus = "standby"; // "standby" | "loading" | "not_available" | "loaded" | "complicated"

    constructor() { }


    async getFlightInfo() {
        this.flightInfoStatus = "loading";
        try {
            let res = await fetch(this.aurelia_options.last_minute_trips_api_location + 'flightinfo?meta_id=' + this.metaId);
            let flights = (await res.json()).flights;
            if (flights.length > 2) {
                this.flightInfoStatus = "complicated";
                return;
            }
            let outbound = (flights === false ? [] : flights).find(x => x.direction == "outbound") ?? null
            let inbound = (flights === false ? [] : flights).find(x => x.direction == "inbound") ?? null
            if (!flights || !outbound || !inbound) {
                this.flightInfoStatus = "not_available";
                await fetch(this.aurelia_options.last_minute_trips_api_location + 'packagegroup/remove_expired?packagegroup_id=' + this.packagegroupId, {
                    method: 'DELETE'
                });
                return;
            }

            this.flightinfo = {
                outbound: outbound ? {
                    departureTime: formatDate(new Date(outbound.departure_time), 'W dd.MM ' + this.aurelia_options.translations.lmt_destination_body_flight_info_at + ' HH:mm', { locale: document.documentElement.lang }),
                    departureCity: outbound.original_departure_name,
                    arrivalTime: formatDate(new Date(outbound.arrival_time), 'HH:mm', { locale: document.documentElement.lang }),
                    arrivalCity: outbound.original_arrival_name,
                    flightCompany: outbound.flight_company,
                    flightNumber: outbound.flight_number,
                } : null,
                inbound: inbound ? {
                    departureTime: formatDate(new Date(inbound.departure_time), 'W dd.MM ' + this.aurelia_options.translations.lmt_destination_body_flight_info_at + ' HH:mm', { locale: document.documentElement.lang }),
                    departureCity: inbound.original_departure_name,
                    arrivalTime: formatDate(new Date(inbound.arrival_time), 'HH:mm', { locale: document.documentElement.lang }),
                    arrivalCity: inbound.original_arrival_name,
                    flightCompany: inbound.flight_company,
                    flightNumber: inbound.flight_number,
                } : null
            };
            this.flightInfoStatus = "loaded";
        } catch (e) {
            this.flightInfoStatus = "standby";
            console.error(e);
        }
    }

    flightinfoFlightToString(flight) {
        if (flight === null) return '-';
        return flight.departureTime + ' - ' + flight.arrivalTime + ', ' +
            flight.departureCity + ' - ' + flight.arrivalCity +
            (flight.flightCompany !== null ? ', ' + flight.flightCompany : '') + 
            (flight.flightNumber !== null ? ' ' + this.aurelia_options.translations.lmt_destination_body_flight_info_flight + ' # ' + flight.flightNumber : '');
    }
}
